import React, {Component} from 'react'
import {RadioGroup, Radio} from 'react-radio-group'
import axios from "axios"

export default class GetResults extends Component {

  getResultsFile = (qcvar) => {
    const url = "qc_results/" + qcvar + "_qc_results.json"
    axios
      .get(url)
      .then(res => {
        this.props.changeState({qcresults: res.data})
        this.props.changeState({qcVar: qcvar})
    })
      .catch(error => {
        if (error.response) {
            console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
        } else if (error.request) {
            console.log(error.request)
        } else {
           console.log('Error', error.message)
        }
        console.log("Error retrieving qc results file: " + (error.config))
      })
  }

  handleChange = (value) => {
    this.props.changeState({qcVar: ""})
    this.props.changeState({stnId: ""})
    this.getResultsFile(value)
  }

  render () {
    return (
      <div>
        <RadioGroup name="qcVar" onChange={this.handleChange} style={{margin:"12px 0"}}>
            <span style={{marginRight:"5px"}}>Select variable:</span>
            {Object.keys(this.props.qcVarNames).map((abb) => (
              <label key={abb} style={{border:"1pt solid black", padding:"3px 8px 3px 5px", backgroundColor:"WhiteSmoke"}}>
                <Radio value={abb} /> {this.props.qcVarNames[abb]}
              </label>
            ))}
        </RadioGroup>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/GetResults.js